import React, { memo } from 'react';
import { View } from 'react-native';
import Text from 'design-system/Text';
import { CurrencyAmountText, Spacer, ToolTip } from 'design-system';
import { rem } from 'design-system/values';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
const BalanceView = ({ title, amount, tooltipTitle, tooltipText }) => {
    const styles = useStyles(styleSet);
    return (<View style={styles.container}>
      <CurrencyAmountText size="L" value={{ amount: amount ? amount.value : 0, currency: amount ? amount.currency : 'GBP' }}/>
      <View style={styles.row}>
        <Text TextThin-14 Gray>
          {title}
        </Text>
        {tooltipTitle !== undefined && tooltipTitle !== '' && tooltipText !== undefined && tooltipText !== '' && (<>
            <Spacer w={4}/>
            <ToolTip title={tooltipTitle} subtitle={tooltipText} colorKey="secondary" small/>
          </>)}
      </View>
    </View>);
};
const styleSet = createStyleSheets(() => ({
    container: {
        alignItems: 'center',
        paddingVertical: rem(16),
        justifyContent: 'center',
    },
    row: {
        flexDirection: 'row',
        alignItems: 'center',
    },
}));
export default memo(BalanceView);
